module.exports = __webpack_public_path__ + "img/2017-1.53ddcc9b.jpeg";